/* import __COLOCATED_TEMPLATE__ from './lowpass-sallenkey.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();